/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneFactBox as ResolvedStandaloneFactBox } from 'base/components/standalone/FactBox';

export const FactBox: typeof ResolvedStandaloneFactBox = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneFactBox {...props} />
        </ErrorBoundary>
    );
});

export type FactBoxProps = PropsFromComponent<typeof FactBox>;

/** @deprecated Use slot architecture instead */
export const FactBoxWith = (extras: DynamicStandaloneExtras): typeof FactBox => {
    return function FactBox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'FactBox');
        return <ResolvedStandaloneFactBox {...mergeProps({ options: { theme } }, props)} />;
    }
}